import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function UnknownPin() {
  const { t } = useTranslation('patterns', { keyPrefix: 'PinMedia' });
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl bg-bg-subtle p-8 text-fg-muted">
      <FileText className="size-10" aria-hidden />
      <span className="text-sm">{t('unknownFile')}</span>
    </div>
  );
}
